import { LOAD_CONFIGURATION, LOG_IN, LOG_OUT, SET_UP_CONFIGURATION, SITE_SELECTED } from '../constants/ActionTypes'

import { DEFAULT_BEAMLINES } from '../constants/Config.js'
import ISPyB from '../config/config.js'
import find from 'lodash/find'

const initialState = {
  sites: [],
  beamlines: { MX: [] },
  dataAnalysis: {},
  settings: {},
  isSAXSenabled: false,
  isMXenabled: false,
  isEMenabled: false,
}

const configuration = (state = initialState, action) => {
  switch (action.type) {
    case SET_UP_CONFIGURATION: {
      const beamlines = {
        SAXS: [
          {
            name: 'SWING',
          },
        ],
        EM: [],
        MX: [
          {
            name: 'PROXIMA1',
            sampleChangerType: '',
          },
          {
            name: 'PROXIMA2A',
            sampleChangerType: '',
          },
        ],
      }
      const site = DEFAULT_BEAMLINES
      state = {
        ...state,
        beamlines,
        settings: find(ISPyB.sites, { name: site }).settings,
        dataAnalysis: find(ISPyB.sites, { name: site }).dataAnalysis,
        isSAXSenabled: (beamlines.SAXS && beamlines.SAXS.length > 0) === true,
        isMXenabled: (beamlines.MX && beamlines.MX.length > 0) === true,
        isEMenabled: (beamlines.EM && beamlines.EM.length > 0) === true,
        sites: [DEFAULT_BEAMLINES],
      }
      break
    }

    case LOG_IN: {
      const beamlines = find(ISPyB.sites, { name: action.site }).beamlines
      state = {
        ...state,
        beamlines: beamlines,
        settings: find(ISPyB.sites, { name: action.site }).settings,
        dataAnalysis: find(ISPyB.sites, { name: action.site }).dataAnalysis,
        isSAXSenabled: (beamlines.SAXS && beamlines.SAXS.length > 0) === true,
        isMXenabled: (beamlines.MX && beamlines.MX.length > 0) === true,
        isEMenabled: (beamlines.EM && beamlines.EM.length > 0) === true,
      }
      break
    }

    case LOAD_CONFIGURATION: {
      if (action.payload) {
        state = { ...state, sites: action.payload }
      } else {
        state = { ...state, sites: [] }
      }
      break
    }
    case SITE_SELECTED: {
      break
    }
    case LOG_OUT: {
      break
    }
    default:
      break
  }
  return state
}

export default configuration
